import { voucherMockData } from "./mock/voucherData";

/**
 * Fetch all vouchers with a simulated network delay
 * @returns {Promise<Array>}
 */
export const getDataByAll = () => {
  return new Promise((resolve) => {
    // Simulasi delay jaringan 800ms
    setTimeout(() => {
      resolve(voucherMockData);
    }, 800);
  });
};

/**
 * Get single voucher by code (untuk validasi input)
 */
export const getVoucherByCode = (code) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const voucher = voucherMockData.find(v => v.code === code);
      resolve(voucher || null);
    }, 400);
  });
};